import Component from 'component';
import Masonry from 'masonry-layout';
import _debounce from 'lodash/debounce';
import _array from 'lodash/array';
import _template from 'lodash/template';
import { BREAKPOINT } from '../constants';
import { jumpToTarget } from '../helpers/jumpToTarget';
import blogItemTpl from '../templates/blogs/blog-listing-item';
import blogFilterTpl from '../templates/blogs/blog-listing-filter';
import blogFilterCollapsedTpl from '../templates/blogs/blog-listing-filter-collapsed';

class BlogListing extends Component {
  constructor(el) {
    super(el);

    this.renderItems();
  }

  setupDefaults() {
    this.blogListId = this.$el.data('blogListId');
    this.endpoint = this.$el.data('endpoint');
    this.displayingItems = 6;

    this.categories = new Set();

    this.dom = {
      $filter: this.$el.find('.blog-listing__filter'),
      $filterToggle: this.$el.find('.blog-listing__filter-toggle'),
      $filterLabel: this.$el.find('.blog-listing__filter-label'),
      $filterDropdown: this.$el.find('.blog-listing__filter-dropdown'),
      $itemList: this.$el.find('.blog-listing__items'),
      $loadMore: this.$el.find('.blog-listing__load-more')
    };

    this.defaultCategory = this.dom.$filterLabel.text();
    this.currentCategory = this.defaultCategory;
  }

  addListeners() {
    $(window).on('click', ::this.onClickOutsideFilter);
    $(window).on('resize', _debounce(::this.handleWindowResize, 100));

    this.dom.$filterToggle.on('click', ::this.toggleFilterDropdown);
    this.dom.$filter.on('click', '.blog-listing__filter-collapsed-options-label', ::this.toggleFilterDropdown);
    this.dom.$filter.on('click', '.blog-listing__filter-option a', ::this.onClickFilterResults);
    this.dom.$loadMore.find('button').on('click', () => ::this.displayItems(true));
  }

  handleWindowResize() {
    this.initFilters();
    this.equalHeights();
  }

  getResults() {
    return $.ajax({
      url: this.endpoint,
      data: { blogListId: this.blogListId },
      context: this
    });
  }

  async renderItems() {
    this.getResults().done(function(result) {
      const { blogs } = typeof(result) === 'object'? result.response : JSON.parse(result).response;

      blogs.forEach((blog, index) => {
        if (blog.category) {
          this.categories.add(blog.category);
        }
        this.dom.$itemList.append(_template(blogItemTpl)({ ...blog, index }));
      });

      this.initFilters();

      // Add masonry
      this.$itemListMsnry = new Masonry(this.dom.$itemList[0], {
        itemSelector: '.blog-listing__item--loaded:not(.blog-listing__item--filtered)'
      });

      // Check if exists filter as hash
      const hash = decodeURIComponent(window.location.hash.substring(1));
      if (hash) {
        jumpToTarget(this.dom.$filter);

        const filter = this.dom.$filter.find('.blog-listing__filter-option a').filter((i, el) => $(el).data('name') === hash.toLowerCase());

        //Update UI
        this.updateFilters($(filter));
        this.filterResults($(filter).text());
      }
      this.displayItems();
    });
  }

  displayItems(loadMore) {
    if (loadMore) {
      this.displayingItems += 6;
    }

    this.dom.$itemList.find('.blog-listing__item').removeClass('blog-listing__item--loaded');

    if (this.displayingItems >= this.dom.$itemList.find('.blog-listing__item:not(.blog-listing__item--filtered)').length) {
      this.dom.$loadMore.hide();
    } else {
      this.dom.$loadMore.show();
    }

    const nonFilteredItems = this.dom.$itemList.find('.blog-listing__item:not(.blog-listing__item--filtered)');
    nonFilteredItems.slice(0, this.displayingItems).addClass('blog-listing__item--loaded');

    this.equalHeights();
  }

  equalHeights() {
    let step = 0;
    const displayingitems = this.dom.$itemList.find('.blog-listing__item--loaded:not(.blog-listing__item--filtered)');
    $(displayingitems).find('.blog-listing__item-content').height('auto');

    if (window.matchMedia(`(min-width: ${BREAKPOINT.desktop}px)`).matches) {
      step = 3;
    } else if (window.matchMedia(`(min-width: ${BREAKPOINT.tablet}px)`).matches) {
      step = 2;
    }

    if (step) {
      for(let i=0; i < displayingitems.length; i+=step) {
        let maxHeight = 0;
        for(let j = 0; j < step; j++) {
          const itemHeight = $(displayingitems[i + j]).find('.blog-listing__item-content').height();
          if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
          }
        }

        for(let j = 0; j < step; j++) {
          $(displayingitems[i + j]).find('.blog-listing__item-content').height(maxHeight)
        }
      }
    }

    this.$itemListMsnry.reloadItems();
    this.$itemListMsnry.layout();
  }

  initFilters() {
    this.dom.$filterDropdown.empty();
    // Add default category
    this.dom.$filterDropdown.append(_template(blogFilterTpl)({ category: this.defaultCategory, name: this.cleanName(this.defaultCategory), isActive: this.currentCategory === this.defaultCategory }));

    // Add categories
    this.categories.forEach(category => {
      this.dom.$filterDropdown.append(_template(blogFilterTpl)({ category, name: this.cleanName(category), isActive: this.currentCategory === category }));
    });

    if (window.matchMedia(`(min-width: ${BREAKPOINT.desktop}px)`).matches) {
      this.resizeFilters();
    }
  }

  cleanName(name) {
    if (name) {
      return name.replace(/[^\w\s]/g, '').replace(/ /g, '-').toLowerCase();
    }
  }

  resizeFilters() {
    const filterWidth = this.dom.$filterDropdown.width();
    let optionsWidth = 85,
      menuCompresed = false;

    this.dom.$filterDropdown.find('.blog-listing__filter-option').each((i, option) => {
      optionsWidth += $(option).innerWidth();

      if (!menuCompresed && optionsWidth > filterWidth) {
        this.dom.$filterDropdown.append(_template(blogFilterCollapsedTpl));
        this.dom.$filterCollapsedOptions = this.dom.$filterDropdown.find('.blog-listing__filter-collapsed-options-dropdown');
        menuCompresed = true;
      }

      menuCompresed && this.dom.$filterCollapsedOptions.append($(option));
    });
  }

  toggleFilterDropdown(e) {
    e.preventDefault();
    e.stopPropagation();

    this.dom.$filter.toggleClass('blog-listing__filter--open');

    if (this.dom.$filter.hasClass('blog-listing__filter--open')) {
      this.dom.$filterToggle.attr('aria-expanded', 'true');
    } else {
      this.dom.$filterToggle.attr('aria-expanded', 'false');
    }
  }

  onClickOutsideFilter() {
    this.dom.$filter.removeClass('blog-listing__filter--open');
    this.dom.$filterToggle.attr('aria-expanded', 'false');
  }

  onClickFilterResults(e) {
    e.preventDefault();
    e.stopPropagation();
    this.updateFilters($(e.currentTarget));
    this.filterResults(this.currentCategory);

  }

  updateFilters($activeFilter) {
    this.dom.$filter.find('.blog-listing__filter-option--active').removeClass('blog-listing__filter-option--active');
    $activeFilter.parent().addClass('blog-listing__filter-option--active');
    this.onClickOutsideFilter();
    this.currentCategory = $activeFilter.text();
    this.dom.$filterLabel.text(this.currentCategory);
  }

  filterResults(category) {
    this.dom.$itemList.find('.blog-listing__item').each((index, item) => {
      if (category === this.defaultCategory) {
        $(item).removeClass('blog-listing__item--filtered');
      } else if (category === $(item).data('category')) {
        $(item).removeClass('blog-listing__item--filtered');
      } else {
        $(item).addClass('blog-listing__item--filtered');
      }
    });
    this.displayItems();
  }

}

export default BlogListing;



// WEBPACK FOOTER //
// ./src/tc/js/components/BlogListing.js